__turbopack_context__.v({
  "backdrop": "CartOutOfStockPopup-module-scss-module__3TeBTW__backdrop",
  "modalCard": "CartOutOfStockPopup-module-scss-module__3TeBTW__modalCard",
  "slideInUp": "CartOutOfStockPopup-module-scss-module__3TeBTW__slideInUp",
});
